import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||39}
    height={undefined}
    style={{aspectRatio:'39/42'}}
    viewBox="0 0 39 42"
    fill="none"
    {...props}
  >
    <g>
      <path
        fill="#00E9BA"
        d="M5.103 35.758h23.845a2.68 2.68 0 0 1 2.677 2.674 2.683 2.683 0 0 1-2.677 2.677H5.103v-5.351Z"
      />
      <path
        fill="#FF6E58"
        d="M10.291 20.043h17.26a1.94 1.94 0 0 1 1.939 1.935 1.942 1.942 0 0 1-1.939 1.939h-17.26v-3.874Z"
      />
      <path
        fill="#3F538D"
        d="M.914 41.106V16.19c0-1.485.81-2.85 2.111-3.566l14.909-11.44a4.033 4.033 0 0 1 3.91 0l14.909 11.44a4.07 4.07 0 0 1 2.111 3.566v24.916H34.53V18.579a2.71 2.71 0 0 0-1.4-2.372L21.2 6.91a2.696 2.696 0 0 0-2.622 0l-11.93 9.296a2.71 2.71 0 0 0-1.4 2.372v22.527H.915Z"
      />
    </g>
  </svg>
)
export default SvgComponent
